import { nullable, number, object, string } from "superstruct";

const InstagramPostBaseMediaSchema = object({
    id: nullable(number()),
    imageSmall: string(),
    imageMedium: string(),
    imageLarge: string(),
});

export default InstagramPostBaseMediaSchema;
